import React, { useCallback, useEffect } from 'react';
import { useFormikContext } from 'formik';
import PilotItem from './item/PilotItem';
import useStyles from './PilotList.styles';

const PilotList = () => {
  const classes = useStyles();

  const { values, setFieldValue } = useFormikContext();

  const checkIfLastEntryIsDirty = useCallback(() => {
    const lastPilot = values.pilots[values.pilots.length - 1];
    return !!(lastPilot && (lastPilot.name || lastPilot.licenseNumber));
  }, [values.pilots]);

  useEffect(() => {
    if (checkIfLastEntryIsDirty()) {
      setFieldValue(`pilots.${values.pilots.length}`, {
        id: 0,
        name: '',
        licenseNumber: '',
      });
    }
  }, [checkIfLastEntryIsDirty, setFieldValue, values.pilots]);

  const handleDelete = useCallback(
    (index) => {
      const { pilots } = values;
      const cleanedPilots = [...pilots];
      cleanedPilots[index].isDeleted = true;
      cleanedPilots.splice(cleanedPilots.length - 1, 1);
      setFieldValue('pilots', cleanedPilots);
    },
    [setFieldValue, values]
  );

  return (
    <div className={classes.root}>
      {values.pilots.map((pilot, index) => (!pilot.isDeleted ? <PilotItem key={String(index)} index={index} onDelete={handleDelete} /> : null))}
    </div>
  );
};

PilotList.propTypes = {};

PilotList.defaultProps = {};

export default PilotList;
